// helpers/tab-container.js

(function (window) {
  const SELECTOR = "[data-component=tab-container]";
  const { document } = window;

  function click(e) {
    const { target } = e;
    const container = target.closest(SELECTOR);
    const selected = target.closest("button");
    const buttons = selected.closest("header").querySelectorAll("button");
    const sections = container.querySelectorAll(":scope > section");
    const [id, index] = selected.id.split("-");

    buttons.forEach((button) => {
      button.classList.remove("solid");
    });
    selected.classList.add("solid");
    sections.forEach((section) => section.setAttribute("hidden", ""));
    document.getElementById(`${id}-tab-${index}`).removeAttribute("hidden");
  }

  function setInitActiveTab() {
    const defaultActiveButtons = document.querySelectorAll(
      `${SELECTOR} header ol li:first-child button`,
    );

    defaultActiveButtons.forEach((btn) => {
      btn.classList.add("solid");
    });
  }

  function init() {
    document
      .querySelectorAll(SELECTOR)
      .forEach((conntainer) => conntainer.addEventListener("click", click));

    setInitActiveTab();
  }

  document.addEventListener("DOMContentLoaded", init, { once: true });
})(globalThis);
